import React from 'react';
import Msg from '../i18n/Msg';

export default class TenantDropdown extends React.Component {
  constructor() {
    super();

    this.state = {
      tenant: null
    }
  }

  componentWillMount() {
    if(this.props.user.queryParams.tenantId) {
      this.props.user.queryParams.tenantId = ((localStorage.getItem('tenant') === null) ? this.props.user.queryParams.tenantId : localStorage.getItem('tenant')) ;
      this.setState({
        tenant: this.props.user.queryParams.tenantId
      })
    }
  }
  componentWillReceiveProps(nextProps) {
    if (window.performance) {
      if (performance.navigation.type === 1) {
        return;
      } 
    }
    if (nextProps.user.queryParams.tenantId !== this.state.tenant) {
      this.setState({
        tenant: nextProps.user.queryParams.tenantId
      })
    }
  }

  render() {
    let tenants = this.props.tenants;
    const selectedTenant = tenants.find((el) => el.id === this.state.tenant);
    const currentTenant = selectedTenant ? selectedTenant['name'] : "Choose Tenant";
    return (
      <div className="project-context hidden-xs dropdown">
        <span className="label">
          <Msg phrase="Tenant" />:
        </span>
        <span
          className="project-selector dropdown-toggle"
          data-toggle="dropdown"
        >
          {currentTenant}&nbsp;
          {tenants.length ? <i className="fa fa-angle-down" /> : null}
        </span>

        {tenants.length ? (
          <ul className="dropdown-menu">
            <li className={`${this.state.tenant === null ? 'active' : ''}`}>
              <a onClick={() => this.props.changeTenant(null)}>
                Choose Tenant
              </a>
            </li>
            {tenants.map((tenant, idx) =>(
                <li key={idx} className={`${this.state.tenant === tenant.id ? 'active' : ''}`}>
                  <a onClick={() => this.props.changeTenant(tenant.id)}>
                    {tenant.name} {tenant.dbName ? `(${tenant.dbName})` : ''}
                  </a>
                </li>
              )
            )}
          </ul>
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/TenantDropdown.js